import React, { useState } from 'react'

import { Box, Button, Typography } from '@material-ui/core'

import { BaseDialog, MenuButton, Permitted } from 'components'
import { KpiMetricsDialog } from '../'
import constants from 'constants/index'
import * as service from 'service'
import helpers from 'helpers'
import useSnackbar from 'hooks/useSnackbar'

const ActionButtons = ({
  monitoringManagementKpi,
  monitoringManagementKpiMetric,
  refresh,
}) => {
  const [dialogMode, setDialogMode] = useState(null)
  const [fullMetric, setFullMetric] = useState(null)
  const [destroyOpen, setDestroyOpen] = useState(false)
  const [destroyLoading, setDestroyLoading] = useState(false)

  const snackbar = useSnackbar()

  const handleOpen = async (mode) => {
    if (mode === 'isShow' || mode === 'isEdit') {
      try {
        const response =
          await service.dponet.monitoringManagementKpiMetrics.show({
            monitoringManagementKpiId: monitoringManagementKpi?.id,
            monitoringManagementKpiMetricsId: monitoringManagementKpiMetric?.id,
          })
        setFullMetric(response?.data?.monitoringManagementKpiMetric)
      } catch {
        snackbar.open({
          message: 'Erro ao carregar os detalhes da métrica.',
          variant: 'error',
        })
        return
      }
    }
    setDialogMode(mode)
  }

  const handleClose = () => {
    setDialogMode(null)
    setFullMetric(null)
  }

  const handleDestroy = async () => {
    try {
      setDestroyLoading(true)
      await service.dponet.monitoringManagementKpiMetrics.destroy({
        monitoringManagementKpiId: monitoringManagementKpi?.id,
        monitoringManagementKpiMetricsId: monitoringManagementKpiMetric?.id,
      })
      setDestroyOpen(false)
      refresh()
      snackbar.open({
        message: 'Métrica excluída com sucesso.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao excluir métrica.',
        variant: 'error',
      })
    } finally {
      setDestroyLoading(false)
    }
  }

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <MenuButton>
          <Permitted
            tag={constants.permissions.MONITORING_MANAGEMENT_KPI.MANAGE}
          >
            <Button
              color="secondary"
              fullWidth
              onClick={() => handleOpen('addMetric')}
            >
              Adicionar Métrica
            </Button>
            <Button
              color="secondary"
              fullWidth
              onClick={() => handleOpen('isEdit')}
            >
              Editar
            </Button>
          </Permitted>
          <Button
            color="secondary"
            fullWidth
            onClick={() => handleOpen('isShow')}
          >
            Detalhes
          </Button>
          <Permitted
            tag={constants.permissions.MONITORING_MANAGEMENT_KPI.MANAGE}
          >
            <Button
              color="secondary"
              fullWidth
              onClick={() => setDestroyOpen(true)}
            >
              Excluir
            </Button>
          </Permitted>
        </MenuButton>
      </Box>
      <BaseDialog
        open={destroyOpen}
        setOpen={setDestroyOpen}
        title="Excluir Métrica"
        closeButtonText="Cancelar"
        actionButtonText="Excluir"
        actionButton={handleDestroy}
        loading={destroyLoading}
        dialogSize="sm"
        justifyActions="flex-end"
        fullWidth
      >
        <Box py={2}>
          <Typography variant="subtitle1">
            Tem certeza que deseja excluir a métrica de ID{' '}
            <strong>{monitoringManagementKpiMetric?.id}</strong>? Esta ação não
            pode ser desfeita.
          </Typography>
        </Box>
      </BaseDialog>
      <KpiMetricsDialog
        open={!!dialogMode}
        setOpen={handleClose}
        monitoringManagementKpi={monitoringManagementKpi}
        monitoringManagementKpiMetric={
          dialogMode === 'isShow' || dialogMode === 'isEdit'
            ? fullMetric
            : monitoringManagementKpiMetric
        }
        refresh={refresh}
        addMetric={dialogMode === 'addMetric'}
        isShow={dialogMode === 'isShow'}
        isEdit={dialogMode === 'isEdit'}
      />
    </>
  )
}

export default ActionButtons
